import React from 'react';
import styled from 'styled-components';

import { HoverUnderline } from "../styleComponents/HoverStyles"

const StyledAnchor = styled.a`
color:var(--color-secondary);
:hover{
  border:none;
  color:var(--color-text);
}
`;


const Anchor = (props) => {
  return (
    <HoverUnderline>
      <StyledAnchor {...props} rel="noopener noreferrer"/>
    </HoverUnderline>
  )
}
export default Anchor;